import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";
import { WHATSAPP_NUMBER } from "../config";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-col">
          <h4>KRIVAEXIM</h4>
          <p>Your trusted partner in global trade.</p>
        </div>
        <div className="footer-col">
          <h4>Company</h4>
          <Link to="/about">About</Link>
          <Link to="/products">Products</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="footer-col">
          <h4>Contact</h4>
          <p>info@krivaexim.com</p>
          <p><a href="tel:+918830149701">+91 8830149701</a></p>
          <p><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">WhatsApp Us</a></p>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} KrivaExim. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;
